import React, { useEffect, useRef } from "react";
import "mathlive";
import "mathlive/fonts.css";

const MathEditor = ({
  value = "",
  onChange,
  onCommit,
  readOnly = false,
  className = "",
  ariaLabel = "Math editor",
}) => {
  const fieldRef = useRef(null);

  useEffect(() => {
    const field = fieldRef.current;
    if (!field) return;
    if (typeof value === "string" && field.value !== value) {
      field.value = value;
    }
  }, [value]);

  useEffect(() => {
    const field = fieldRef.current;
    if (!field) return;
    field.readOnly = !!readOnly;
  }, [readOnly]);

  useEffect(() => {
    const field = fieldRef.current;
    if (!field) return;
    const handleInput = () => {
      if (typeof onChange === "function") onChange(field.value);
    };
    const handleBlur = () => {
      if (typeof onCommit === "function") onCommit(field.value);
    };
    field.addEventListener("input", handleInput);
    field.addEventListener("blur", handleBlur);
    return () => {
      field.removeEventListener("input", handleInput);
      field.removeEventListener("blur", handleBlur);
    };
  }, [onChange, onCommit]);

  return (
    <math-field
      ref={fieldRef}
      className={className}
      aria-label={ariaLabel}
    />
  );
};

export default MathEditor;
